import { addDays } from 'date-fns/addDays';
import { format } from 'date-fns/format';
export const DEFAULT_START_MONTH_INDEX = 0;
export const DEFAULT_MAX_MONTH_INDEX = 11;
const MAX_DATE_DISTANCE_IN_DAYS = 330;
const MAX_SELECT_RANGE_IN_DAYS = 32;
export const PRICELINE_DATE_FORMAT = 'yyyyMMdd';
const now = Date.now();
export const defaultToday = format(now, PRICELINE_DATE_FORMAT);
export const defaultMaxDate = format(addDays(now, MAX_DATE_DISTANCE_IN_DAYS), PRICELINE_DATE_FORMAT);
export const defaultMaxSelectableDate = format(addDays(now, MAX_SELECT_RANGE_IN_DAYS), PRICELINE_DATE_FORMAT);